import React from 'react';
import HoverActionHeader from '@/components/HoverActionHeader';
import SystemFlag from '@/components/SystemFlag';

const UserGroupFieldHeader = ({
  canEdit,
  category,
  code,
  icon,
  isSystem,
  renderSystemFlag = () => <SystemFlag />,
  showEdit,
  value,
}) => (
  <HoverActionHeader
    canEdit={canEdit}
    className="aridhia-usergroup-list-header"
    icon={icon}
    isSystem={isSystem}
    renderSystemFlag={renderSystemFlag}
    showEdit={() => showEdit(category, code)}
    value={value}
  />
);

export default UserGroupFieldHeader;
